import React, { useState, useEffect } from 'react';
import styles from './AgreementPanel.module.css';
import { InnocodeButton } from '@intsoft/innocode-core';

function AgreementPanel({ onNext, onAgreementChange }) {
  const [isAllAgreed, setIsAllAgreed] = useState(false);
  const [agreements, setAgreements] = useState({
    term: false,
    privacy: false,
  });
  const [openDetails, setOpenDetails] = useState({
    term: false,
    privacy: false,
  });

  useEffect(() => {
    const allChecked = Object.values(agreements).every((agreed) => agreed);
    setIsAllAgreed(allChecked);
    onAgreementChange(agreements); // 부모 컴포넌트로 상태 전달
  }, [agreements]);

  const handleAllAgreement = (checked) => {
    setAgreements({
      term: checked,
      privacy: checked,
    });
  };

  const handleIndividualAgreement = (key, checked) => {
    setAgreements((prev) => ({
      ...prev,
      [key]: checked,
    }));
  };

  const handleDetailToggle = (key) => {
    setOpenDetails((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // 필수 약관인 term과 privacy가 모두 체크되었는지 확인
  const isNextButtonEnabled = agreements.term && agreements.privacy;

  return (
    <>
      <div className={styles.signup_section}>
        <div className={styles.signup_title_row}>
          <div className={`innocode-typography--title-sm innocode-typography--bold ${styles.signup_title}`}>이용약관 동의</div>
        </div>
        <div className={styles.signup_form_label_row}>
          <div className={styles.terms_wrap}>
            <div className={styles.term_row}>
              <label className={styles.circle_checkbox}>
                <input
                  type="checkbox"
                  aria-label="약관 전체동의"
                  className={styles.circle_checkbox__input}
                  checked={isAllAgreed}
                  onChange={(e) => handleAllAgreement(e.target.checked)}
                />
                <span className={`material-symbols-outlined ${styles.circle_checkbox_icon}`}>
                  check
                </span>
              </label>
              <div className={styles.term_row_label}>약관 전체동의</div>
            </div>
            <div className={styles.terms_group}>
              <div className={styles.term_row}>
                <label className={styles.icon_checkbox}>
                  <input
                    type="checkbox"
                    aria-label="이용약관 동의(필수)"
                    className={`${styles.icon_checkbox__input}`}
                    checked={agreements.term}
                    onChange={(e) => handleIndividualAgreement('term', e.target.checked)}
                  />
                  <span className={`material-symbols-outlined ${styles.icon_checkbox__icon}`}>
                    check
                  </span>
                </label>
                <div
                  className={styles.term_item_card}
                  onClick={() => handleDetailToggle('term')}
                >
                  <div className={styles.term_content_flex}>
                    <div className={styles.term_title}>이용약관 동의(필수)</div>
                  </div>
                  <div className={styles.arrow_icon_box}>
                    <span className={`material-symbols-outlined ${styles.term_check_icon}`}>
                      {openDetails.term ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                    </span>
                  </div>
                </div>
              </div>
              <div className={`${styles.term_details_box} ${openDetails.term ? styles.is_open : ''}`}>
                <div className={styles.term_details_inner}>
                  <div className={styles.term_details_heading}>이용약관 동의</div>
                  <div className={`${styles.term_details_text} ${styles.pre_wrap_text}`}>
                      {`[Zentry 서비스 이용약관]
                      제 1장 총칙

                      제 1조 (목적) : 
                      본 약관은 인트소프트(주)(이하 “회사”)와 회사가 운영하는 Zentry 사이트(PC, 모바일 어플리케이션, 모바일웹 등을 모두 포함하여 “Zentry 사이트”라 함), 익명 상담, 커뮤니티, 상담, 검사, 챗봇 등 Zentry 사이트를 통해 제공하는 모든 서비스 (이하 “Zentry 서비스”)를 이용하는 이용자 및 회원과의 권리, 의무, 책임, 제반 절차 및 기타 필요한 사항을 규정함을 목적으로 합니다. 회사의 서비스를 이용하거나 회원으로 가입할 경우 이용자는 본 이용 약관 및 관련 운영 정책을 확인, 동의하게 됩니다. 

                      제 2조 (용어의 정의)
                          1. 본 약관에서 사용하는 용어의 정의는 아래와 같습니다.
                      가. ‘서비스’란  유∙무선 단말기의 종류와는 상관없이 이용 가능한 회사가 제공하는 모든 서비스를 의미합니다.
                      나. ‘이용자’란 회사 서비스에 접속하여, 이 약관에 따라 회사가 제공하는 서비스를 이용하는 회원과 비회원을 말합니다.
                      다. ‘회원’이란 회사와 서비스 이용 계약을 체결한 개인 또는 기업을 말합니다.
                      라. ‘닉네임’이란 회원식별과 회원의 서비스 이용을 위하여 회원이 선정하고 회사가 승인하는 문자열을 말합니다.
                      마. ‘비밀번호'란 회원이 사용하는 이메일과 일치하는 회원임을 확인하고 회원의 비밀 보호를 위해 회원 자신이 설정한 문자와 숫자의 조합을 말합니다.
                      바. '탈퇴'란 회원 또는 회사가 서비스 개통 후 통합 서비스 이용계약을 해약하는 것을 말합니다.
                      사. '콘텐츠'란 회사가 제작 또는 회원이 업로드 하거나, 제휴사가 제공하는 동영상, 이미지, 텍스트 등 전부를 말합니다.
                      아. ‘전문가’란 회사와 계약을 체결하고 회사의 서비스를 통해 용역을 제공하는 상담, 검사 등을 제공하는 사람들을 말합니다. 
                      자. ‘유료 서비스’란 회사의 서비스 이용을 위해 이용자가 일정한 대가를 지급하고 구매하는 서비스 상품을 말합니다. 

                          2. 본 조에서 정하지 않은 용어의 정의는 관련 법령 및 일반적인 상관례에 따릅니다.

                      제 3조 (약관의 효력 및 변경)
                      ① 본 약관은 서비스를 이용하고자 하는 모든 회원에게 그 효력이 발생합니다.  
                      ② 회원이 회사의 서비스 이용을 위해 회원가입을 진행하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 회사가 운영하는 서비스를 지속적으로 사용하는 것에 동의함을 의미합니다. 변경된 약관에 대한 정보를 알지 못하여 발생하는 회원의 피해에 대하여 회사는 책임이 없습니다. 
                      ③ 회사는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법 약관의 규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있습니다.
                      ④ 회사가 약관을 변경할 경우에는 시행일  7일 전부터 적용일자와 변경사유를 서비스 화면에 게시하거나 기타의 방법으로 공지합니다. 다만, 변경 내용이 회원에게 불리할 수 있는 중대한 내용의 약관 변경의  경우에는 그 적용일자 30일 전부터 해당 서비스 내에 고지하고 서비스 홈페이지에 게시하거나 회원에게 전자적 형태(전자우편, SMS 등)로 고지합니다. 
                      이용자가 연락처를 기재하지 않았거나 변경하여 발송이 어려울 경우에는 본 서비스 화면에 변경 약관을 공지하는 것을 개별 발송한 것으로 간주합니다. 
                      ⑤ 회사가 본 조 제4항에 따라 변경약관을 공지하거나 통지하면서, 회원이 약관 변경 적용일까지 거부 의사를 표시하지 아니하면 약관 변경에 동의한 것으로 간주한다는 내용을 공지 또는 통지하였음에도 회원이 변경된 약관의 효력 발생일까지 약관 변경에 대한 거부 의사를 표시하지 않을 때에는 회원이 변경약관에 동의한 것으로 간주합니다. 회원은 변경된 약관에 동의하지 않으면 본 서비스의 이용을 중단하고 이용계약을 해지 할 수 있습니다.   
                      ⑥ 회사는 이용자가 요구하면 본 약관의 사본을 이용자에게 교부하며, 이용자가 서비스 내에서 본 약관을 인쇄할 수 있도록 조치합니다. 
                      ⑦  회사는 서비스 중 특정 서비스에 적용하기 위한 약관(이하 “개별약관”이라 함)을 별도로 제정할 수 있으며, 이용자가 개별약관에 동의한 경우 개별약관은 이용계약의 일부를 구성합니다. 개별약관에 본 약관과 상충하는 내용이 있을 경우 달리 정함이 없는 한 개별약관의 내용이 우선 적용됩니다. 
                      ⑧ 회사는 본 약관에 세부적으로 규정되지 않는 내용에 대해 상세히 정하기 위하여 운영정책을 제정할 수 있고, 본 약관 및 운영정책의 구체적인 적용 및 Zentry 서비스의 이용방법을 안내하는 도움말을 작성하여 안내할 수 있으며, 해당 내용을 Zentry 서비스 또는 Zentry 사이트를 통해 게시합니다.


                      제 4조 (관계법령의 적용)
                      본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령 또는 상관례에 따릅니다.

                      제 5조 (회원가입)
                      ① 회원이 되고자 하는 이용자는 회사가 정한 절차에 따라 이 약관과 개인정보처리방침, 개인정보의 수집, 제공 및 활용 동의서에 동의함으로써 회원 가입을 신청합니다. 
                      ② 모든 회원은 반드시 본인의 이메일 또는 회원가입에 필요한 정보를 제공하고 회원가입을 완료해야만 서비스를 이용할 수 있습니다. 
                      ③  모든 회원은 가입 시 지정한 비밀번호에 의한 활동이나 행위 일체에 대한 책임을 부담합니다. 회사는 회원에게 강력한 비밀번호(대∙소문자, 숫자 및 특수문자를 조합한 형태의 비밀번호)를 설정할 것을 권장합니다. 회원의 Zentry 사이트 계정 닉네임과 비밀번호에 대한 보호 및 관리 책임은 회원 본인에게 있고, 이를 제3자가 이용하도록 허락할 수 없으며, 이 정보가 유출되지 않도록 관리해야 합니다.
                      ④  회원은 자신의 계정 닉네임 및 비밀번호가 도용되었거나 유출된 것을 인지한 즉시 회사에 통지하고, 회사의 안내에 따라야 합니다. 회사에 그 사실을 통지하지 않거나 통지한 경우라도 회사의 안내를 따르지 않아 발생한 불이익에 대해서 회사는 회사의 고의 또는 과실이 없는 한 책임지지 않습니다.
                      ⑤ 회사는 회원의 개인정보 유출 우려가 있는 경우 해당 회원 계정의 이용을 제한할 수 있으며, 이러한 경우 회원가입시 기재해 주신 이메일을 통해 회원에게 통지합니다. 단, 이메일을 기재하지 않은 상태에서 회원가입을 하였을 경우에 책임은 회원에게 있습니다.
                      ⑥ 회원가입계약의 성립시기는 이용자가 서비스에 접속하여 정보 입력 및 약관에 동의 후 가입을 완료하여 콘텐츠를 볼 수 있는 서비스 화면에 접속한 시점으로 합니다. 
                      ⑦ 이용자가 서비스를 이용하면서 기재하는 모든 정보는 실제 데이터인 것으로 간주되며, 허위의 정보를 입력한 이용자는 법적인 보호를 받을 수 없고, 서비스 이용에 제한을 받을 수 있습니다. 
                      ⑧ 정확한 정보를 등록하지 않은 이용자는 일체의 권리를 주장할 수 없으며, 타인의 정보를 도용하여 회원가입을 한 회원의 모든 계정은 삭제되며 관계 법령에 따라 처벌을 받을 수 있습니다. 
                      ⑨ 회사는 아래 사항에 해당하는 경우에 대하여 회원 가입 신청을 거부할 수 있으며, 가입이 된 이후에도 아래의 사유가 확인된 경우에는 승낙을 취소할 수 있습니다. 
                          1)  타인의 정보를 이용하거나 허위의 내용으로 신청한 경우 
                          2)  사회의 질서를 저해할 목적으로 신청한 경우 
                          3)  영리를 추구할 목적으로 본 서비스를 이용하고자 하는 경우 
                          4)  부정한 용도로 본 서비스를 이용하고자 하는 경우 
                          5)  회원이 서비스 이용정지 등 이용제한을 받은 후 그 이용제한 기간 중에 이용계약을 임의해지하고 다시 가입 신청을 하는 경우
                          6)  기술상 또는 업무상 장애 등 회사의 사유로 가입 신청의 승낙이 어려운 경우
                          7)  기타 회원으로서 가입 신청이 본 약관 또는 관련 법령을 위반하거나 부당하여 승낙 거부가 필요하다고 회사가 판단하는 경우
                      ⑩ 회원은 가입 시 회사에 제공한 정보에 변경이 있을 경우 즉시 전자우편, 기타 방법으로 회사에 그 변경사항을 알려야 하며,  알림 지연으로 인하여 발생한 불이익에 대해서 회사는 회사의 고의 또는 과실이 없는 한 책임지지 않습니다. 

                      제 6조 (계정 해지 및 회원탈퇴)
                      회원은 언제든지 회원 탈퇴 또는 계정 해지를 진행하거나 회사에 요청할 수 있으며 이 경우 회사는 개인정보처리방침에 따라 이를 지체없이 처리합니다. 회사의 서비스 이용계약이 해지되면, 회사는 개인정보처리방침에 따라 해당 회원의 정보 삭제를 위한 절차를 밟습니다.
                      다만, 이 경우에도 게시글과 댓글 등 회원이 등록한 게시물은 삭제되지 않으므로 반드시 해지 신청 이전에 삭제하신 후 탈퇴하시기 바랍니다. 

                      제 7조 (회사의 권리 및 의무)
                      ① 회사는 관련 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 본 약관이 정하는 바에 따라 지속적이고, 안정적인 서비스를 제공하기 위해 노력합니다. 
                      다만, 천재지변, 비상사태, 정기점검, 설비장애 또는 이용 폭주 등으로 인하여 서비스 이용에 지장이 있을 경우 등 부득이한 경우에는 그 서비스를 일시 중단하거나 중지할 수 있습니다. 
                      ② 회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보 보호를 위해 보안시스템을 구축하며 개인정보처리방침을 공시하고 준수합니다. 
                      ③ 회사는 회원이 서비스 이용과 관련하여 정당하다고 인정되는 의견과 불만을 제기할 경우 이를 처리하여야 합니다. 
                      ④ 회사는 회원이 서비스를 이용함에 있어 법률적인 증명이 가능한 고의 또는 중대한 과실을 입힐 경우 이로 인한 손해를 배상할 책임이 있습니다.
                      ⑤ 회사는 서비스의 향상과 신규 서비스의 개발, 상담 인공지능 등 관련 연구 등을 위하여 회원의 상담 요청 내용, 거래내역, 상담 내용 등 서비스 제공 과정에서 작성된 모든 자료와 정보를 익명화하여 수집하거나 수정하여 통계, 마케팅, 상담 및 검사 인공지능 등 회사의 서비스 관련 연구 및 개발 등에 활용할 수 있습니다.
                      ⑥ 회사는 서비스 향상과 홍보를 위하여 서비스 내에 작성된 이용 후기 등의 콘텐츠를 기타 포털사이트 등에 제휴와 협약 등을 통해 게시하거나 전송할 수 있습니다.

                      제 8조 (전문가의 권리 및 의무)
                      ① 제휴된 전문가는 회사의 서비스를 통해 회원에게 용역을 제공할 수 있습니다. 
                      ② 제휴된 전문가는 회사의 요청이 있는 경우, 서비스와 관련된 자격증 정보 등 최소한의 정보를 회사에 공개해야 합니다. 단, 정보를 전달함에 있어 거짓이 없어야 하며, 회사가 관련 증명서류를 요청할 경우 이에 응해야 합니다.
                      ③ 제휴된 전문가는 회사 서비스의 지적재산권을 침해하는 행위를 해서는 안됩니다. 
                      ④ 제휴된 전문가는 회원의 개인정보를 본 약관에서 정한 목적 이외의 용도로 사용하거나 제 3자에게 제공하는 등 외부에 유출할 수 없으며, 관련 법령, 본 약관, 운영정책 등에 따라 철저히 보호하여야 합니다.
                      ⑤ 제휴된 전문가는 서비스 제공과정에서 획득한 회원정보와 상담내용에 대하여 비밀준수의무를 지닙니다. 
                      ⑥ 제휴된 전문가가 본 조를 위반하여 회원 등으로부터 문제 제기가 있는 경우, 회사를 면책시켜야 하며, 전문가 본인이 관련 법령에 따른 민,형사상 법적 책임 등 일체의 책임을 직접 부담하여야 합니다. 
                      ⑦ 제휴된 전문가는 광고, 스토킹 등 회사 서비스의 취지에 부합하지 않는 목적으로 서비스를 이용하는 회원에 대하여 회사 또는 경찰 등에 신고할 수 있습니다.

                      제 9조 (회원의 권한 및 의무)
                      ① 이용자는 회원가입 또는 회원정보 변경 시 본인에 대한 정확한 정보를 사실에 근거하여 작성해야 합니다. 허위 또는 타인의 정보로 작성할 경우 일체의 권리를 주장할 수 없습니다. 
                      ② 회원은 관련 법령, 본 약관 및 운영정책에서 정한 의무 등 내용을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 해서는 안됩니다. 이를 지키지 않을 경우, 서비스 이용에 제한을 받거나 법적조치를 포함한 제재를 받을 수 있습니다. 
                      ③ 회원은 이메일 주소 등 정보가 변경된 경우에 회사에 즉시 알려야 합니다. 회사가 관계법령 및 ‘개인정보처리방침’에 의거하여 그 책임을 지는 경우를 제외하고 회원의 계정, 비밀번호 등의 관리 소홀, 부정 사용으로 인하여 발생하는 모든 결과에 대한 책임은 회원에게 있습니다.
                      ④ 회원은 상품 등을 구매하기 전에 반드시 회사가 제공하는 상품 등의 상세 내용과 조건을 정확하게 확인한 후 구매해야 합니다. 회원이 이를 확인하지 아니하거나 오인하여 발생한 문제에 대하여 회사는 회사의 고의 또는 과실이 없는 한 책임을 지지 않습니다.
                      ⑤ 회원은 회사가 서비스를 안전하게 제공할 수 있도록 회사에 협조해야 하며, 회사가 회원의 이 약관 위반 행위를 발견하여 회원에게 해당 위반 행위에 대하여 소명을 요청할 경우 회원은 회사의 요청에 적극 응하여야 합니다. 
                      ⑥ 미성년자인 회원이 서비스를 이용하여 상품 등을 구매 시 법정대리인이 해당 계약에 대하여 동의를 하여야 정상적인 상품 등의 구매계약이 체결될 수 있습니다. 만약, 미성년자인 회원이 법정대리인의 동의 없이 상품 등을 구매하는 경우 본인 또는 법정대리인이 이를 취소할 수 있습니다. 
                      ⑦ 회원이 회사가 제공하는 유료 서비스를 통해 전문가로부터 상담을 받기 위해서는 유료 서비스를 구매해야하며, 이에 대한 환불은 회사가 공지하는 환불규정을 따라야 합니다. 
                      ⑧ 회원은 상담에 필요한 최소한의 구체적이고 진실한 정보를 제공하여야 하며, 정보가 부족할 경우, 서비스 이용에 제한을 받을 수 있습니다. 
                      ⑨ 전문가는 회사와 제휴관계에 있음을 인식하고, 회원은 전문가의 귀책사유 있는 불법 내지 위법행위를 알게 된 경우 회사에 해당 사실을 통지하며, 회사는 관련 사실관계를 확인하고 전문가의 해촉 등 필요한 조치를 취합니다. 
                      ⑩ 본조 9항의 경우, 회원은 전문가에 대한 책임 청구 이외에 회사에 대하여는 전문가의 귀책사유 있는 불법 내지 위법행위에 대한 책임을 물을 수 없습니다. 
                      ⑪ 회사에서 제공하는 결제 서비스를 통하지 않는 전문가와 구매회원 간의 직거래는 이용제한 사유에 해당하며 이로 인해 발생하는 불이익에 대해 회사는 회사의 고의 또는 과실이 없는 한 책임지지 않습니다.
                      ⑫ 서비스 이용제한 및 이용계약 해지와 관련하여 구체적인 해석 및 절차 등 본 약관에서 상세히 정하지 아니한 사항은 운영정책에서 정합니다.

                      제 10조 (회원의 개인정보 보호)
                      ①  회사는 관계법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 회원이 회사에 제공하는 정보 일체는 회사의 개인정보처리방침에 따릅니다. 단, 회사의 공식사이트와 어플리케이션 이외의 회사에 링크되어 있는 웹사이트들에서는 회사의 개인정보처리방침이 적용되지 않습니다. 
                      ② 회사는 이용자의 귀책사유로 인해 노출된 정보에 대해서 일체의 책임을 지지 않습니다. 또한 회사는 회원에게 서비스 관련 공지사항 및 행정적 사항을 제공할 필요가 있을 수 있습니다. 이러한 사항은 본 서비스 및 회원계정의 일부로 간주되며, 회원은 이를 수신거부 할 수 없습니다.

                      제 11조 (회원의 금지행위)
                      ① 회원은 다음 각 호에 해당하는 행위를 해서는 안되며, 해당행위를 하는 경우 서비스의 일부 또는 전부를 이용 정지하거나 서비스 이용 계약을 임의로 해지할 수 있으며, 이 경우 발생하는 손해에 대한 책임은 회원이 부담합니다. 회사는 필요한 경우 회원의 금지행위 사실을 관련 정부기관 또는 사법기관에 통지할 수 있으며 회원은 적법조치를 포함한 제재를 받을 수 있습니다.  
                          1)  서비스 이용 신청 또는 변경 시 허위 사실을 기재하거나, 타인의 정보를 도용하여 부정하게 사용하는 행위
                          2)  회사가 게시한 정보를 무단으로 변경하는 행위
                          3)  회사가 정한 정보 이외의 정보를 송신하거나 게시하는 행위 
                          4)  회사와 기타 제 3자의 저작권 등 기타 권리를 침해하는 행위
                          5)  회사 및 기타 제 3자의 명예를 손상시키거나 업무를 방해하는 행위
                          6)  불특정 다수를 대상으로 하여 광고 또는 선전을 게시하거나 음란물 또는 불쾌감을 조성할 수 있는 글을 게시하는 행위
                          7)  회사의 서비스를 이용하여 얻은 정보를 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위 
                          8)  욕이나 음담패설, 외설적 또는 규정에 적합하지 않는 행위
                          9)  컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해 또는 파괴할 적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 전송하는 행위
                          10) Zentry 서비스의 안정적 운영을 방해하거나 Zentry 서비스의 장애를 발생시킬 수 있는 모든 행위
                          11) 회사의 동의 없이 영리 목적으로 서비스를 사용하는 행위
                          12) 기타 회사가 서비스의 이용제한이 필요하다고 판단하여 운영정책에서 금지한 행위
                      ② 회원이 서비스 이용 과정에서 욕이나 음담패설, 외설적 행위를 할 경우 피해 주체가 된 전문가는 증빙 자료 확보 및 법적조치를 위해 회원의 금지행위에 대해 녹음/녹화등의 수단을 활용하여 적절한 조치가 취해질 때까지 보유할 수 있으며, 이 과정에서 회원의 개인정보가 수집될 수 있습니다. 
                      ③ 회원은 귀책사유로 인하여 회사나 다른 회원이 입은 손해를 배상할 책임이 있습니다.

                      제 12조 (서비스 이용 제한) 
                      ① 회사는 이용자가 관련 법령, 본 약관, 운영정책을 위반하거나, 타인의 권리를 침해하는 행위를 하거나, 그러한 위법, 부당한 행위가 있는 것으로 의심될 만한 상당한 이유가 있는 경우 본 약관 및 운영정책에서 정하는 바에 따라 Zentry 서비스의 이용을 제한(이하 본조에서 정하는 Zentry 서비스 이용에 관한 각종 제한 등을 “이용제한 등"이라 함)할 수 있습니다. 
                      ② 회사는 회원에게 다음 각 호의 사유가 발생한 경우, 회원에 대한 Zentry 서비스 이용제한, 중단, 이용계약 해지 등의 조치를 취할 수 있으며, 구체적인 기준 및 절차는 운영정책에서 정합니다.
                          1)  다른 회원 또는 제3자를 비방하거나 허위의 사실을 적시하여 명예를 훼손하는 경우 
                          2)  음란물, 욕설 등 공서양속에 위반되는 내용의 정보, 문장, 도형 등을 유포하는 경우 
                          3)  범죄행위와 관련이 있다고 판단되는 내용의 콘텐츠를 게시하는 경우 
                          4)  다른 회원 또는 제3자의 저작권 등 기타 권리를 침해하는 내용 
                          5)  종교적, 정치적 분쟁을 야기하는 내용을 기재해 분쟁을 발생시키거나 이러한 분쟁으로 인하여 회사의 업무가 방해되거나 방해되리라고 판단되는 경우 
                          6)  타인의 개인정보, 사생활을 침해하거나 명예를 훼손하는 경우 
                          7)  동일한 내용을 중복하여 다수 게시하는 등 게시의 목적에 어긋나는 경우
                          8)  불필요하거나 승인되지 않은 광고, 판촉물을 게재하는 경우
                          9)  기타 관련 법령, 본 약관, 운영정책에 위반되는 행위
                      ③ 회사는 회원에게 Zentry 서비스 본 조에 따른 이용제한 등을 하는 경우, 본 약관에서 달리 정함이 없는 한 이메일 등의 방법으로 회원에게 통지 합니다. 단, 부득이한 사유가 있는 경우 먼저 이용제한 조치를 한 뒤 사후에 통지할 수 있습니다. 
                      ④ 회원이 작성한 ’콘텐츠’로 인한 법률상 이익 침해를 근거로, 다른 회원 또는 제3자가 회원 또는 회사를 대상으로 하여 민형사상의 법적 조치(예: 고소, 가처분신청, 손해배상청구소송)를 취하는 동시에 법적 조치와 관련된 게시물의 삭제를 요청해오는 경우, 회사는 동 법적 조치의 결과(예: 검찰의 기소, 법원의 가처분결정, 손해배상판결)가 있을 때까지 관련 게시물에 대한 접근을 임시적으로 제한할 수 있습니다.



                      제 2장 서비스 이용

                      제 13조 (서비스의 내용) 
                      회사는 Zentry를 통해 상담, 검사, 챗봇 등 이용자에게 도움이 될 수 있는 다양한 서비스를 제공하고 있으며 구체적인 내용은 아래와 같습니다. 회사의 서비스에는 기본적으로 본 약관이 적용되지만, 다양한 서비스를 제공하는 과정에서 부득이 본 약관 외 별도의 약관, 운영정책등을 적용하는 경우가 있습니다(예, Zentry 케어센터). 이러한 내용은 각각의 해당 서비스나 웹사이트 등에서 확인해주시기 바랍니다. 회사는 회원에게 본 약관에 따라 아래와 같은 Zentry 서비스를 제공할 수 있으며, 필요할 경우 제 3자에게 위탁하여 제공할 수 있습니다.
                      ① 전문가와 채팅, 전화 등을 통해 상담을 할 수 있도록 텍스트/음성 등의 기능 제공, 연결 및 예약 기능, 진행 및 결과에 대한 정보 제공 기능 등 
                      ② 회원이 예약한 서비스와 관련된 알림 기능
                      ③ 후기 및 평가를 작성하고 공유하는 서비스
                      ④ 자가진단을 위한 콘텐츠
                      ⑤ 상담 목적의 챗봇
                      ⑥ 통신판매(결제 관련 내용)
                      ⑦ 기타 회사가 본 서비스와 부합하며, 회원의 편의성을 향상시킨다고 판단하여 제공하는 모든 서비스 

                      제 14조 (서비스 이용계약)
                      ① 서비스 이용계약은 이용자가 회사가 정한 이용약관에 대하여 동의하고 회원가입에 필요한 온라인 신청 양식을 작성하여 서비스 이용을 신청한 후 이에 대하여 회사가 승인함으로써 성립합니다.
                      ② 회원이 유료 서비스를 이용하고자 할 경우 이용 전 준수사항 등을 확인하고 회사에서 요청하는 내용에 대해 응답 및 동의를 해야합니다. 
                      ③ 유료 서비스를 구매한 후 이용신청의 정정, 취소 및 환불을 원할 경우 회원은 회사의 환불 규정 및 절차에 따라 이를 진행하여야 합니다. 

                      제 15조 (서비스 이용자격)
                      ① 미성년자인 회원이 서비스를 이용하여 유료 서비스를 구매하고자 할 경우, 법정대리인으로부터 서비스 이용에 대한 동의를 받아야 합니다. 이 경우 법정대리인은 이용약관에서 규정하는 회원의 권리 및 의무를 모두 갖게 됩니다.
                      ② 본 서비스를 이용하려면 앱(Application) 또는 웹(PC)이 반드시 필요하며, 정기적인 업데이트가 필요할 수 있습니다. 또한 이러한 요인에 의해 일부 기능이 영향을 받을 수 있으며, 이용자는 해당 내용에 대해 이해하고 있어야 합니다.

                      제 16조 (서비스 이용 시 주의 사항)
                      ① 회사는 컨텐츠 중개자로 제공하는 컨텐츠에 대해 책임지지 않습니다.

                      제 17조 (서비스 이용요금)
                      ① 회사가 제공하는 유료 서비스는 명시된 요금을 지불해야만 사용할 수 있습니다.
                      ② 회사는 유료 서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수 있습니다.
                      ③ 유료 서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관계법에 따릅니다.
                      ④ 회원의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.
                      ⑤ 무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 회원이 가입한 각 이동통신사의 정책에 따릅니다.
                      ⑥ 비대면 상담 등 유료 전화 서비스 이용시 인터넷 환경의 문제로 시스템 전화 연결이 불안정할 경우 별도의 통신 방법을 이용하여 상담이 진행될 수 있습니다. 이 때 통화료는 발신자 부담이며, 발생 비용은 각 이동통신사의 정책에 따릅니다. 
                      제 18 조 (서비스 내용 변경 통지 등)
                      회사는 다음 각 호의 사유에 해당하여 부득이하게 Zentry 서비스 제공이 불가능한 경우 Zentry 서비스를 일시 중단할 수 있습니다.
                      1-1. 정기점검 및 설비의 보수 등이 필요한 경우
                      1-2. 기간통신사업자의 전기통신 서비스 중단 등 제 3자의 귀책사유가 있는 경우
                      1-3. 천재지변 및 국가비상사태 등으로 정상적인 서비스가 불가능한 경우
                      1-4. 기타 통제할 수 없는 기술상 및 업무상 장애
                      본 조에 따라 Zentry 서비스를 중단하는 경우 구체적인 기준은 운영정책에서 정하며, 회사는 중단사유와 중단기간을 명시하여 홈페이지 또는 앱 공지를 통해 사전에 회원에게 통지합니다. 단, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우에는 사후에 통지할 수 있습니다.  
                      ① 회사가 서비스 내용을 변경하거나 종료하는 경우 회사는 등록된 회원의 전자우편 주소로 서비스 내용의 변경 사항 또는 종료를 통지할 수 있습니다.
                      ② ①항의 경우 불특정 다수인을 상대로 통지를 함에 있어서 회사는 웹사이트 등 기타 회사의 공지사항을 통하여 회원들에게 통지할 수 있습니다.

                      제 19조 (회원정보와 서비스 이용정보)
                      ① 회원은 언제든지 자신의 개인정보를 열람하고 수정할 수 있습니다.
                      ② 회원이 전항의 변경사항을 수정하지 않아 불이익이 발생하였을 경우, 이에 대해 회사는 책임지지 않습니다. 
                      ③ 회원은 유료 상담 등의 서비스를 이용하기 위하여 상담 전 상담 접수지를 작성하여 제출하여야 합니다. 또한 상담 접수지를 통해 수집되는 내용은 서비스의 특성상 민감 정보가 포함 될 수 있다는 사실을 인정해야합니다. 
                      ④ 서비스 제공 및 이용을 위하여 수집된 회원의 개인정보와 상담 내용 등은 회사와 제휴된 전문가 공유하며, 개인정보 수집과 관련된 세부내용은 개인정보처리방침을 따릅니다. 
                      ⑤ 비대면 상담 등 유료 전화 서비스 이용시 인터넷 환경의 문제로 시스템 전화 연결이 불안정할 경우 별도의 통신방법을 이용하여 상담이 진행될 수 있습니다. 이 때 회원의 전화번호가 담당 전문가에게 노출될 수 있으며 담당 전문가는 이를 그 어느 누구와도 공유하지 않습니다. 
                      ⑥ 회원의 개인정보, 상담, 회사가 운영하는 플랫폼에 회원이 게시한 글 등 서비스와 관련된 모든 정보와 자료는 회사가 보관하며, 회사는 전문가와 공유할 수 있습니다. 또한 회원은 상기 서비스와 관련된 모든 정보와 자료는 더 나은 서비스를 위하여 인공지능을 비롯한 회사의 서비스 개발과 연구, 통계, 빅데이터 활용, 마케팅 등에 활용될 수 있다는 사실에 동의하고 인정합니다.

                      제 20조 (이용계약의 해지)
                      ① 회원이 이용계약의 해지를 원할 경우, 서비스 내의 회원 탈퇴 기능을 통하여 언제든지 회원탈퇴를 신청할 수 있습니다. 단, 해지의사를 통지하기 전에 현재 진행 중인 모든 상품의 거래를 완료하거나 규정에 맞게 취소 또는 환불을 진행하여야 하며, 거래를 취소했을 때 발생할 수 있는 불이익은 회원 본인이 부담하여야 합니다. 
                      ② 회원 탈퇴로 인해 발생한 불이익에 대한 책임은 회원 본인이 부담하여야 하며, 이용계약이 종료되면 회사는 회원에게 부가적으로 제공한 각종 혜택을 회수할 수 있습니다. 
                      ③ 회사는 불가피한 사정이 없는 한 회원의 탈퇴 요청을 처리해야 합니다. 
                      ④ 회사는 회원이 본 이용약관 또는 관계법령 등을 위반하는 경우, 회원의 이용계약 해지 신청이 없을 경우에도 이용계약을 해지할 수 있습니다.


                      제 3장 기타

                      제 21조 (저작권) 
                      ① 회사는 지적재산권을 존중하며, 본 서비스 이용자들이 타인의 지적재산권을 존중할 것이라 기대합니다. 
                      ② 회사가 제공하는 서비스, 회사가 개발한 검사지, 해설지 및 기타 모든 저작물에 대한 저작권, 기타 지적재산권 및 기타 모든 콘텐츠는 회사에 귀속됩니다. 회원은 회사가 제공하는 서비스를 이용함으로써 얻은 정보를 회사의 사전 허락 없이 복제, 재가공, 전송, 출판, 배포, 방송, 기타 방법에 의하여 영리 목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.
                      ③ 회원이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 저작자에게 귀속됩니다. 단, 회사는 서비스의 운영, 전시, 전송, 배포, 홍보의 목적으로 별도의 회원 허락 없이 무상으로 저작권법에 규정하는 공정한 관행에 합치되는 합리적인 범위 내에서 회원이 등록한 게시물을 사용할 수 있습니다. 
                      ④ 회원과 전문가가 상담과정에서 작성하는 상담내용과 게시하는 글 또는 회사가 운영하는 플랫폼에 게시하는 글 등 저작물의 저작권 또는 저작물의 이용권은 회사에 무상으로 영구적으로 귀속되며, 회사는 모든 자료와 정보를 익명화하여 수집하여 상담과 관련한 연구 및 개발, 통계, 마케팅에 활용할 수 있습니다. 또한, 빅데이터 활용 또는 연구를 위해 제 3자에게 재이용권을 허락할 수 있습니다. 

                      제 22조 (서비스 게시물의 등록 및 관리) 
                      ① 회원은 약관에서 규정하는 범위 내에서 자율적으로 게시물을 작성할 수 있습니다. 
                      ② 회원의 게시물이 정보통신망법 및 저작권법 등 관련법에 위반되는 내용을 포함하였을 경우, 권리자는 관련법이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있으며, 회사는 관련법에 따라 조치를 취하여야 합니다. 또한, 회사는 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다.

                      제 23조 (광고)
                      회사는 본 서비스에 당사 또는 제3자의 광고를 게재할 수 있으며, 회원은 회사의 마케팅 수신 동의를 한 것으로 간주됩니다.

                      제 24조 (손해배상)
                      ① 회사가 관계법령에 따른 규정을 위반해 회원에게 손해가 발생한 경우 회원은 회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.
                      ② 회원이 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는 회원에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회원은 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.

                      제 25조 (면책조항)
                      ① 회사는 아래의 각 호에 해당하는 경우 책임이 면제되며 이로 인한 손해를 배상할 책임도 없습니다. 
                          1)  천재지변, 전쟁 및 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없을 경우
                          2)  기간통신 사업자가 전기통신 서비스를 중지하거나 정상적으로 제공하지 아니하여 손해가 발생한 경우 
                          3)  서비스용 설비의 보수, 교체, 정기점검, 공사 등의 부득이한 사유로 손해가 발생할 경우 
                          4)  서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제 3자의 고의적인 서비스 방해가 있는 경우
                          5)  회원의 귀책사유로 인해 서비스 이용의 장애 또는 손해가 발생할 경우
                          6)  이용자의 컴퓨터 오류에 의해 손해가 발생할 경우, 또는 회원이 신상정보 및 이메일 주소를 부정확하게 입력하거나 비밀번호를 부실하게 입력하여 손해가 발생할 경우 
                          7)  회원이 서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 경우
                          8)  회원이 서비스를 이용하면서 얻은 자료로 손해가 발생할 경우 
                          9)  회원이 서비스를 이용하며 타 회원으로 인해 정신적 피해를 입게 된 경우 
                          10) 회원이 서비스를 이용하면서 자료를 게시,전송, 저장, 조회함으로써 법적인 책임이 발생한 경우
                          11) 회원 상호간 및 회원과 제 3자 상호 간에 서비스를 매개로 분쟁이 발생한 경우
                          12) 회원이 검사지와 해설지 등 회사에서 제공하는 콘텐츠가 맞지 않다고 판단하는 경우
                      ② 회사는 회원에게 무료로 제공하는 서비스의 이용과 관련해서는 어떠한 손해도 책임을 지지 않습니다.
                      ③ 회사는 제휴된 전문가가 서비스와 관련하여 게재한 정보, 자료, 사실의 신뢰도와 정확성 등의 내용에 대하여 전문가가 기존에 회사에 제출한 서면 자료의 위조 또는 변조, 기타 사유에 의해 정보가 허위임을 인지하지 못했을 경우에 대해 책임을 지지 않습니다.
                      ④ 회사는 회원에게 플랫폼을 제공하는 역할을 담당하며, 전문가의 상담 내용에 대한 진위 등을 판단할 수 없습니다.
                      ⑤ 회사는 회원과 전문가의 상담을 진행하는 과정에서 발생한 분쟁에 대해 개입할 수 없고 이로 인한 손해를 배상할 책임이 없습니다.  

                      제 26조 (규정의 준용)
                      ① 본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.
                      ② 본 약관에 규정되지 않은 사항에 대해서는 관련법령 및 상관습을 따릅니다.

                      제 27조 (분쟁의 조정 및 기타)
                      ① 회사와 회원은 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여 서로 성실하게 노력하여야 합니다. 
                      ② 회사가 제공하는 서비스는 합법적인 목적으로만 사용되어야 하며, 대한민국 법령에 반하는 형태의 사용은 금지됩니다. 회원의 금지된 형태의 사용으로 인하여 손해가 발생할 경우 회사는 이에 대해 책임을 지지 않습니다.
                      ③ 회사와 회원간에 발생한 전자상거래 분쟁과 관련하여 회원의 피해 구제 신청이 있는 경우에는 공정거래위원회 또는 시도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.
                      ④ 서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 회사의 본사 소재지를 관할하는 법원을 관할 법원으로 합니다.



                      [부칙]
                      공고일자: 2025.09.16
                      시행일자: 2025.`}
                  </div>
                </div>
              </div>
              <div className={styles.term_row}>
                <label className={styles.icon_checkbox}>
                  <input
                    type="checkbox"
                    aria-label="개인정보 수집 이용 동의(필수)"
                    className={`${styles.icon_checkbox__input}`}
                    checked={agreements.privacy}
                    onChange={(e) => handleIndividualAgreement('privacy', e.target.checked)}
                  />
                  <span className={`material-symbols-outlined ${styles.icon_checkbox__icon}`}>
                    check
                  </span>
                </label>
                <div
                  className={styles.term_item_card}
                  onClick={() => handleDetailToggle('privacy')}
                >
                  <div className={styles.term_content_flex}>
                    <div className={styles.term_title}>
                      개인정보 수집 이용 동의(필수)
                    </div>
                  </div>
                  <div className={styles.arrow_icon_box}>
                    <span className={`material-symbols-outlined ${styles.term_check_icon}`}>
                      {openDetails.privacy ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                    </span>
                  </div>
                </div>
              </div>
              <div className={`${styles.term_details_box} ${openDetails.privacy ? styles.is_open : ''}`}>
                <div className={styles.term_details_inner}>
                  <div className={styles.term_details_heading}>
                    개인정보 수집 이용 동의
                  </div>
                  <div className={`${styles.term_details_text} ${styles.pre_wrap_text}`}>
                    {`[개인정보 처리 방침]

                    인트소프트(주)(이하 ‘회사’)는 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.

                    제1조 (개인정보의 처리 목적)
                    회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

                    1. 홈페이지 회원가입 및 관리
                    회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지·통지, 고충처리 목적으로 개인정보를 처리합니다.

                    2. 서비스 제공
                    콘텐츠 제공, 맞춤 서비스 제공, 본인인증, 연령인증, 요금결제·정산 등을 목적으로 개인정보를 처리합니다.

                    3. 마케팅 및 광고에의 활용
                    신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.

                    제2조 (개인정보의 처리 및 보유 기간)
                    ① 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
                    ② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
                    1. 홈페이지 회원 가입 및 관리 : 사업자/단체 홈페이지 탈퇴 시까지
                        다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지
                        1) 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지
                        2) 홈페이지 이용에 따른 채권·채무관계 잔존 시에는 해당 채권·채무관계 정산 시까지
                    2. 전자상거래에서의 계약·청약철회, 대금결제, 재화 등 공급기록 : 5년

                    제3조 (처리하는 개인정보의 항목)
                    회사는 다음의 개인정보 항목을 처리하고 있습니다.
                    1. 필수항목 : 이메일, 비밀번호, 닉네임
                    2. 선택항목 : 이름, 연락처
                    3. 서비스 이용 과정에서 IP 주소, 쿠키, 서비스 이용 기록, 기기정보, 위치정보가 생성되어 수집될 수 있습니다.

                    제4조 (개인정보의 제3자 제공)
                    회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.

                    제5조 (개인정보 처리의 위탁)
                    ① 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
                    - 위탁받는 자 (수탁자): [결제 대행사 이름 등]
                    - 위탁하는 업무의 내용: [결제 처리 등]
                    ② 회사는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리 금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.

                    제6조 (정보주체와 법정대리인의 권리·의무 및 그 행사방법)
                    정보주체는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.

                    제7조 (개인정보의 파기)
                    ① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
                    ② 개인정보 파기의 절차 및 방법은 다음과 같습니다.
                    1. 파기절차: 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
                    2. 파기방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용하며, 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.

                    제8조 (개인정보의 안전성 확보 조치)
                    회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
                    1. 관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육 등
                    2. 기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치
                    3. 물리적 조치: 전산실, 자료보관실 등의 접근통제

                    제9조 (개인정보 보호책임자)
                    ① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                    - 성명: [담당자 이름]
                    - 직책: [담당자 직책]
                    - 연락처: [전화번호], [이메일], [팩스번호]
                    ② 정보주체는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다.

                    제10조 (개인정보 처리방침의 변경)
                    이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.

                    [부칙]
                    공고일자: 2025.09.16
                    시행일자: 2025.`}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.submit_btn_container}>
        <InnocodeButton size="lg" disabled={!isNextButtonEnabled} onClick={() => onNext(agreements)} className={styles.submit_btn}>
          다음
        </InnocodeButton>
        {/* <button
          type="button"
          className={`${components.btn} ${components.btn_solid} ${components.btn_primary} ${components.btn_lg} ${styles.submit_btn}`}
          disabled={!isNextButtonEnabled}
          onClick={() => onNext(agreements)}
        >
          <span className={components.btn__text}>다음</span>
        </button> */}
      </div>
    </>
  );
}

export default AgreementPanel;
